import { useContext, useMemo } from 'react';
import { SelectedFileContext } from '../contexts/selected-file';

export function useOpenedFolder() {
    const { openedFolder, openFolder, openLoadedFolder, reopenFolder } = useContext(SelectedFileContext);
    const currentFolder = useMemo(() => {
        return openedFolder && openedFolder.result ? openedFolder.result : undefined;
    }, [openedFolder])
    return {
        openedFolder,
        openFolder,
        openLoadedFolder,
        reopenFolder,
        currentFolder
    };
}